import apiUrl from '../../../../constants';
import axios from 'axios';
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';

export default {
    name: 'StickerPrintingLogs',
    components: {
		VueElementLoading
	},
    props: {
      shippingId: {
        type: String,
        required: true
      }
    },
    data: function() {
		return {
			barcode:'',
			shipmentData:[],
			isLoading: false,
			showTable:false
		}
	},
    created() {
      console.log('StickerPrintingLogs - Shipping ID:', this.shippingId);
    },
    model: {
    },
    computed: {
    },
    filters: {
        moment: function(date) {
            if (date == null || date == '')
                return '--'
            return moment(date).format('DD-MM-YYYY HH:mm:ss');
        }
    },
    mounted() {
        this.$refs.barcode.focus();
        if (this.shippingId) {
            this.barcode = this.shippingId;
            this.showdetails();
        }
    },
    methods: {
		resetData(){
			this.barcode='',
			this.shipmentData='',
			this.showTable=false,
			this.isLoading=false,
			this.$refs.barcode.focus(),
			this.$validator.reset();
            this.errors.clear();
		},

		showdetails(){
			this.$validator.validateAll().then((result) => {
                if (result) {
					this.shipmentData=[];
					this.showTable=false; this.isLoading=true;
					axios({
							method: 'GET',
							url: apiUrl.api_url_hubops + 'getRTODTOStickerLogs' + "?FlyerShippingId=" + this.barcode + "&isStickerSuccess=true",
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',

							}
						})
						.then(result => {
							this.showTable=true;
							if (result.data.ResultCode == 100) {
								this.shipmentData=result.data.ResponseData;
							} else {
								this.$alertify.error(result.data.ReturnMessage)
							}
							this.isLoading=false;
						}, error => {
							this.isLoading=false;
							console.error(error)
						}
                    )
				}
			});
		}
	},
  };
  


// WEBPACK FOOTER //
// ./src/views/components/AdditionalEventLogs/StickerPrintingLogs/StickerPrintingLogs.js